import { z } from 'zod';
import { isAllowedSeqeraEndpoint } from '../../utils/url-validator';

const SAFE_TEXT_REGEX = /^[^<>{}\\]*$/;
const DISALLOWED_CHARS_MSG = 'Contains disallowed characters (< > { } \\)';

// ID-006 remediation: reject non-Seqera endpoints at the schema level
const seqeraEndpoint = z
  .string()
  .refine((v) => v === '' || isAllowedSeqeraEndpoint(v), {
    message: 'NextFlowTowerApiBaseUrl must be an https Seqera endpoint (api.cloud.seqera.io or *.seqera.io)',
  })
  .optional();

export const OrganizationSchema = z
  .object({
    OrganizationId: z.string().uuid(),
    Name: z.string().min(1).max(50).regex(SAFE_TEXT_REGEX, DISALLOWED_CHARS_MSG),
    Description: z.string().max(500).regex(SAFE_TEXT_REGEX, DISALLOWED_CHARS_MSG).optional(),
    Country: z.string().max(100).optional(),
    AwsHealthOmicsEnabled: z.boolean().optional(),
    NextFlowTowerEnabled: z.boolean().optional(),
    NextFlowTowerApiBaseUrl: seqeraEndpoint,
    CreatedAt: z.string().optional(),
    CreatedBy: z.string().optional(),
    ModifiedAt: z.string().optional(),
    ModifiedBy: z.string().optional(),
  })
  .strict();

export const CreateOrganizationSchema = z
  .object({
    Name: z.string().min(1).max(50).regex(SAFE_TEXT_REGEX, DISALLOWED_CHARS_MSG),
    Description: z.string().max(500).regex(SAFE_TEXT_REGEX, DISALLOWED_CHARS_MSG).optional(),
    Country: z.string().max(100).optional(),
    AwsHealthOmicsEnabled: z.boolean().optional(),
    NextFlowTowerEnabled: z.boolean().optional(),
    NextFlowTowerApiBaseUrl: seqeraEndpoint,
  })
  .strict();

export const UpdateOrganizationSchema = z
  .object({
    Name: z.string().min(1).max(50).regex(SAFE_TEXT_REGEX, DISALLOWED_CHARS_MSG),
    Description: z.string().max(500).regex(SAFE_TEXT_REGEX, DISALLOWED_CHARS_MSG).optional(),
    Country: z.string().max(100).optional(),
    AwsHealthOmicsEnabled: z.boolean().optional(),
    NextFlowTowerEnabled: z.boolean().optional(),
    NextFlowTowerApiBaseUrl: seqeraEndpoint,
  })
  .strict();
